import React from "react";
import { DateRangePicker } from "react-date-range";

import moment, { Moment } from "moment";

import { useEventListener } from "./hook";

type Props = {
	dateRangeStart?: Moment;
	dateRangeEnd?: Moment;
	onDateRangeChanged?: ({
		startDate,
		endDate
	}: {
		startDate: Moment;
		endDate: Moment;
	}) => void;
	selectBlockAmount?: number;
	selectBlockUnit?: "month";
	containerClass?: string;
	inputContainerClass?: string;
	titleIcon?: React.ReactNode;
	label?: string;
	isEnabled?: boolean;
	onRemoveFilter?: () => void;
};

const Calendar = ({
	dateRangeStart,
	dateRangeEnd,
	onDateRangeChanged,
	selectBlockAmount,
	selectBlockUnit,
	isEnabled,
	onRemoveFilter,
	label,
	containerClass,
	inputContainerClass,
	titleIcon
}: Props) => {
	const [selectionRange, setSelectionRange] = React.useState({
		startDate: dateRangeStart?.toDate(),
		endDate: dateRangeEnd?.toDate(),
		key: "selection",
		autoFocus: true
	});

	const ref = React.useRef<any>(null);
	const [isCalendarOpen, setIsCalendarOpen] = React.useState(false);

	const handleClickOutside = (event: any) => {
		if (!ref.current || ref.current.contains(event.target)) {
			return;
		}

		setIsCalendarOpen(false);
	};

	const customEndDateWithBlockSelection = ({ startDate, endDate }: any) => {
		let firstDayPicked = moment(startDate);

		if (!selectBlockAmount) {
			return endDate;
		}

		const dayAdded = firstDayPicked.add(selectBlockAmount, "days");
		if (
			selectBlockUnit === "month" &&
			dayAdded.month() !== moment(startDate).month()
		) {
			firstDayPicked = moment(startDate).endOf("month");
		} else {
			firstDayPicked = dayAdded;
		}

		return firstDayPicked.toDate();
	};

	const handleSelect = (ranges: any) => {
		const endDayCustomed = customEndDateWithBlockSelection(ranges.selection);
		const isSameDate = moment(ranges.selection.startDate).isSame(
			ranges.selection.endDate,
			"hour"
		);

		setSelectionRange({
			...ranges.selection,
			endDate: endDayCustomed
		});

		onDateRangeChanged &&
			!isSameDate &&
			onDateRangeChanged({
				startDate: moment(ranges.selection.startDate),
				endDate: moment(endDayCustomed)
			});
	};

	useEventListener("mousedown", handleClickOutside);
	useEventListener("touchstart", handleClickOutside);

	return (
		<>
			<button
				className={
					isEnabled ? "btn btn-primary btn-sm" : "btn btn-secondary btn-sm"
				}
				onClick={() => {
					setIsCalendarOpen(!isCalendarOpen);
				}}
			>
				<i className="fas fa-calendar" />{" "}
				{moment(dateRangeStart).format("DD/MM/YYYY")} -{" "}
				{moment(dateRangeEnd).format("DD/MM/YYYY")}{" "}
			</button>

			{isEnabled && onRemoveFilter && (
				<button
					className={"btn btn-danger btn-sm mt-2"}
					onClick={onRemoveFilter}
				>
					<i className="fas fa-trash mt-2" /> Xoá lọc
				</button>
			)}

			{isCalendarOpen && (
				<div
					className="shadow-lg"
					ref={ref}
					style={{
						position: "absolute",
						right: "0px",
						top: "0px",
						zIndex: 9999
					}}
				>
					<DateRangePicker
						showMonthAndYearPickers={true}
						ranges={[selectionRange]}
						onChange={handleSelect}
						dateDisplayFormat={"d MMM yyyy"}
						focusedRange={selectBlockAmount ? [0, 0] : undefined}
						showMonthArrow
					/>
				</div>
			)}
		</>
	);
};

export default Calendar;
